<template>
    <div class="controlbarwrapper" @keydown="onKeyDown" tabindex="0" @focus="onFocus" ref="bar" @blur="onBlur"
            @click="onClick">
        <slot></slot>
    </div>
</template>

<script>
export default {
  Name: 'ControlbarWrapper',
  data() {
    return {
      selectedComponent: 0
    };
  },
  mounted() {
    console.log('toolbar mounted', this);

    this.selectedComponent = this.nextEnabledComponent(-1, 1);
  },
  methods: {
    onKeyDown(event) {
      console.log('toolbar key', event);
      const oldSel = this.selectedComponent;
      if (event.key === 'ArrowRight') {
        if (event.ctrlKey) {
          return;
        }
        this.selectedComponent = this.nextEnabledComponent(this.selectedComponent, 1);
      } else if (event.key === 'ArrowLeft') {
        if (event.ctrlKey) {
          return;
        }
        this.selectedComponent = this.nextEnabledComponent(this.selectedComponent, -1);
      } else if ((event.key === ' ') || (event.key === 'Enter') || (event.key === 'ArrowDown') ||
        (event.key === 'ArrowUp') || (event.key === 'Escape')) {
        if (this.$children[this.selectedComponent].onToolbarAction(event.key, this)) {
          event.stopPropagation();
        }
        return;
      } else {
        return;
      }
      event.stopPropagation();
      if (this.selectedComponent < 0) {
        this.selectedComponent = 0;
      } else if (this.selectedComponent >= this.$children.length) {
        this.selectedComponent = this.$children.length - 1;
      }
      if (oldSel !== this.selectedComponent) {
        console.log('change sel', oldSel, this.selectedComponent);
        this.$children[oldSel].onToolbarAction('hide', this);
        this.$children[oldSel].$el.classList.remove('selected');
        this.$children[this.selectedComponent].$el.classList.add('selected');
      }
    },
    reFocus() {
      this.$nextTick(() => {
        console.log('toolbar refocus');
        this.$refs.bar.focus();
      });
    },
    onFocus() {
      this.$children[this.selectedComponent].$el.classList.add('selected');
    },
    onBlur() {
      this.$children[this.selectedComponent].$el.classList.remove('selected');
    },
    onClick(evt) {
      console.log(evt);
      for (let i = 0; i < this.$children.length; i++) {
        const e = this.$children[i].$el;
        if (e) {
          if (e.contains(event.target)) {
            this.selectedComponent = i;
          }
        }
      }
    },
    nextEnabledComponent(start, step) {
      let i = start + step;
      do {
        if ((i >= this.$children.length) || (i < 0)) {
          return start;
        }
        console.log('toolbar item', this.$children[i]);
        if ((this.$children[i].$el.attributes && this.$children[i].$el.attributes.getNamedItem) &&
          (this.$children[i].$el.attributes.getNamedItem('aria-disabled') === null) &&
          (this.$children[i].$el.style.display !== 'none')) {
          return i;
        }
        i += step;
      } while (true);
    }
  }
};
</script>

<style lang="scss">
    @import '../assets/bootstrap-style.scss';
    .controlbarwrapper {
        outline: none;
        &:focus {
            // outline: 1px solid $gray-400;
        }
        margin-right: 10px;
        // flex: 0 0 auto;
        // white-space: nowrap;
        //height: 30px;
        .ib_wrap {
            // margin-left: 0;
            // padding: 5px;
            transition: background-color 0.3s;
            border-radius: 3px;
            outline: none;
            &.isActive {
                background-color: $toolbar-active;
                &:hover {
                    background-color: $toolbar-hover;
                }
            }
            border: 1px solid transparent;
            &:hover {
                background-color: $toolbar-hover;
            }
        }
        .cb-section {
            display: inline-block;
        }
        .cb-right {
            float: right;
        }
    }
</style>
